// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'


// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

// Vue.component('l-map', LMap)
// Vue.component('l-tile-layer', LTileLayer)
// Vue.component('l-marker', LMarker)

import router from '@/router/index'
import axios from '@/lib/axiosClient'

import App from '@/App'

import moment from 'moment'
import VueCookies from 'vue-cookies'

import {defaultConfig} from '@/components/config/config.js'
import {defaultStore} from '@/components/config/store.js'

import {COOKIE, CONFIG, IS_DEV, API_KEY, HTTP_PROTOCOL} from '@/components/Data'
import {API_BASE_URL} from '@/lib/env'

import AccessMixins from '@/mixins/AccessMixins'
import * as authLib from '@/lib/auth'
import { stripSensitiveState } from '@/lib/persistState'
import safeHtml from '@/directives/safeHtml'

window.jQuery = window.$ = require('jquery')

Vue.use(Vuex)
Vue.use(VueCookies)
Vue.directive('safe-html', safeHtml)

Vue.config.productionTip = false

// Remove old config, exposes too much info.
if (localStorage.getItem(CONFIG)) {
  localStorage.removeItem(CONFIG)
}

var config = JSON.parse(sessionStorage.getItem(CONFIG))
var value = JSON.parse(localStorage.getItem(COOKIE))

var saveStore = true

config = (!config ? defaultConfig : config)
value = (!value ? defaultStore : value)

if (value) {
//  value.isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1
//  value.isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1
//  value.isMozilla = navigator.userAgent.toLowerCase().indexOf('mozilla') > -1
  value.env = process.env.NODE_ENV
  // KAN-39: prefer the build-time API_BASE_URL when present (always trailing /).
  if (API_BASE_URL) {
    value.endpoint = API_BASE_URL.replace(/\/+$/, '') + '/'
  } else {
    value.endpoint = IS_DEV ? 'http://localhost:8000/' : HTTP_PROTOCOL + location.hostname + '/'
  }
  value.hostname = IS_DEV ? 'http://localhost:8080/' : HTTP_PROTOCOL + location.hostname + '/'
  value.copyright = 'xolas.io ' + moment().format('YYYY')
  value.windowWidth = window.width
  value.windowHeight = window.height
  saveStore = false
}

const store = new Vuex.Store(
  {
    // KAN-39: do NOT persist the auth slice via vuex-persistedstate.
    // Tokens live in localStorage (shared across tabs since XOL-151) and are hydrated below.
    plugins: [createPersistedState({
      key: COOKIE,
      reducer: stripSensitiveState
    })],
    state: value
  }
)

// KAN-39: wire lib/auth.js to the Vuex store, then hydrate tokens
// from localStorage so reload (and new tabs) do not log the user out.
authLib.setStore(store)
authLib.hydrateFromStorage()
if (authLib.isAuthenticated()) {
  store.state.isLoggedIn = true
}

if (saveStore) {
  this.saveStore()
  saveStore = false
}

// KAN-39: Authorization: Bearer is injected by the axios request interceptor
// in src/lib/axiosClient.js for authenticated endpoints. X-API-Key remains
// the bootstrap credential for pre-JWT endpoints (POST /api/login,
// /api/register) because the API's XolasAuth middleware still gates them on
// it. The middleware prefers Bearer when present, so sending both on
// authenticated requests is harmless.
axios.defaults.headers.common['X-API-Key'] = API_KEY
axios.defaults.headers.common['Accept'] = 'application/json'

if (IS_DEV) {
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('XDEBUG')) {
    axios.defaults.params = {
      'XDEBUG_TRIGGER': '1'
    }
  }
}

Vue.mixin(
  {
    computed: {
      screenWidth: function () {
        return this.getStore().windowWidth
      },

      isPhone: function () {
        return this.XSmall
      },

      isMobile: function () {
        return this.isSmall
      },

      isTablet: function () {
        return this.isMedium
      },

      isLaptop: function () {
        return this.isLarge
      },

      isDesktop: function () {
        return this.isHuge
      },

      isXSmall: function () {
        return this.$mq === 'xs'
      },

      isSmall: function () {
        return this.$mq === 'sm'
      },

      isSmallOrMore: function () {
        return !this.isXSmall
      },

      isMediumOrLess: function () {
        return (this.isMedium || this.isSmall || this.isXSmall)
      },

      isMedium: function () {
        return this.$mq === 'md'
      },

      isMediumOrMore: function () {
        return (this.isMedium || this.isLarge || this.isHuge)
      },

      isLarge: function () {
        return this.$mq === 'lg'
      },

      isLargeOrMore: function () {
        return (this.isLarge || this.isHuge)
      },

      isHuge: function () {
        return this.$mq === 'hg'
      },

      company: function () {
        if (this.org()) {
          return this.org().name
        } else {
          return 'No name'
        }
      }

    },

    methods: {

      /**
       Gets: latest config changes (selects, orgs, etc.) and
       stores in:

       config: local storage
       user: session storage

       */
      init () {

        // -- Check for schema changes.
        var changesUrl = this.getEndpoint('system/changes')
/*
        if (IS_DEV) {
          console.log('Checking for changes in schema')
        }
*/
        axios.get(changesUrl).then(response => {

          let data = response.data
          let urls = []
/*
          if (IS_DEV) {
            console.log('System changes:', data, data.length)
          }
*/
          for (var i = 0; i < data.length; i++) {

            urls.push(changesUrl + data[i])

          }

          axios.all(urls).then(resp2 => {
//            console.log(resp2.data)
            this.getConfig().meta[data[i]] = resp2.data
          })
          .catch(e => {
            console.error('Error getting schema for ', e)
          })

        })
        .catch(e => {
          console.error('Error Downloading Schema changes: ', e)
        })

        this.updateConfig()

        var clientUrl = this.getEndpoint('system/client')

        axios.get(clientUrl).then(response => {

          store.state.xolasClient = response.data
//          this.getStats(this.org() ? this.org().id : null, true)
          store.state.baseMap = {lat: (response.data.latitude ? Number(response.data.latitude) : 3.0), lng: (response.data.longitude ? Number(response.data.longitude) : 105.0)}
          this.saveStore()
/*
          if (IS_DEV) {
            console.log('Cookie:', store.state)
          }
*/
          store.state.reloadClient = false

          console.log('Client:', this.xolasClient().name)
        })
        .catch(e => {
          //          this.xolasClient().name = 'Tower Management System'
          this.getStore().reloadClient = true
//        @TODO fix vuex store.
//         console.error('Error Loading Client Info: ', e)
        })

        return false
      },


      refreshBrowser () {
        window.location.reload()
      },



      /**
       @param {String} path - reponse item from server.
       @param {Number} id = null

       @return {String} - valid path to server

       Wraps the path with the full host name, HTTP protocol
       */
      getEndpoint (path, id = null, attachOrg = true, checkSessionExp = true) {

        if (!path.startsWith('/')) {
          path = '/' + path
        }

        // KAN-39: removed legacy `api_token_expiry` soft check.
        // Session validity is enforced by the JWT `exp` claim and the
        // axios interceptor (silent refresh + reactive retry).

        if (attachOrg && this.org()) {

          if (id) {
            path = path + '/' + id
          }

          let orgId = null
          let orgCategory = null

          if (this.org().id) {
            orgId = this.org().id
          }

          if (this.org().category) {
            orgCategory = this.org().category.trim()
          }

          if (path.indexOf('orgCategory') === -1) {
             let pr = path.indexOf('?') > 0 ? '&' : '?'
            path = path + (orgId ? pr + 'orgId=' + orgId + (orgCategory ? '&orgCategory=' + orgCategory : '') : '')
          }

        }

        return store.state.endpoint + 'api' + path
      },



      /**
       @param {Object} response - reponse item from server.
       @param {Boolean} showMessage = true - the ID of the record to delete.
       @param {String} title = 'Operation Failed to Complete'
       @param {String} timeout = 6500 - in milisseconds

       Checks the reponse for 'error' or 'warning' props, and shows relevant
       message to the user.
       */
      checkWarning (response, showMsg = true, title = 'Operation Failed to Complete', timeout = 6500) {

        if (response && response.status !== 200 && response.data && (response.data.warning || response.data.error)) {

          if (showMsg) {

            this.$notify(
              {
                title: response.data.title ? response.data.title : title,
                message: response.data.message ? response.data.message : (response.data.error ? response.data.error : response.data.warning),
                type: response.data.error ? 'error' : 'warning',
                duration: timeout
              })
          }
          return true
        }

        return false
      },



      // -- Config stuff ------------------------------------------------

      getConfig () {
        return config
      },



      updateConfig () {
        // Get config.
        var configUrl = this.getEndpoint('system/config')

        axios.get(configUrl).then(response => {
          config = response.data
          sessionStorage.setItem(CONFIG, JSON.stringify(config))
        })
        .catch(e => {
          // KAN-39: 401 handled centrally in src/lib/axiosClient.js
          this.getStore().reloadClient = false
          console.error('Error Loading Config Info: ', e)
        })
      },


      // -- Store stuff ------------------------------------------------

      getStore () {
        return store.state
      },



      saveStore () {
        if (store && store.state) {

          if (store.state.apiKey) {
            delete store.state.apiKey
          }

          // KAN-39: strip the auth slice before writing to localStorage.
          // Tokens must not be double-persisted via this legacy path; the
          // canonical localStorage write happens in src/lib/auth.js (XOL-151).
          // The strip here keeps saveStore() from racing the lib's writes.
          const persistable = stripSensitiveState(store.state)
          localStorage.setItem(COOKIE, JSON.stringify(persistable))
/*
          if (IS_DEV) {
            console.log('Store saved: ', store.state)
          }
*/
        } else {
          this.$message({message: 'Error saving state, undefined state or store', type: 'error'})
        }
      },



      resetStore () {

        store.state.isLoggedIn = false
        store.state.profile = {id: null, name: null, shortName: null}
        store.state.org = {id: null, name: null, shortName: null}
        store.state.stats = {}
        store.state.statsError = false
      },


      // -- Stats stuff ------------------------------------------------

      /**
      * getStats
      * @param orgId Number: default null
      *
      * @return Object
      */
      getStats(orgId = null, force = false) {

        if (force || this.isEmptyObject(this.getStore().stats)) {
          this.refreshStats(orgId ? orgId : this.profile().organisation_id)
        }

        return this.getStore().stats
      },



      /**
      * refreshStats
      * @param orgId Number: default null
      * @param callback Function:  default null
      *
      * @return Object
      */
      refreshStats (orgId = null, callback = null) {

        // @TODO        this.$emit('update-stats')

        if (this.getStore().reloadClient) {
          this.getStore().reloadClient = false
          this.init()
        }

        if (!orgId && this.isTelco()) {
          orgId = this.org().id
        }

        var url = this.getEndpoint('stats' + (this.isTowerCo() ? '/all' : '/org') )

        axios.get(url).then(response => {

          if (!this.isUndefined(response.data[0])) {
            this.getStore().stats = response.data[0]
            this.getStore().statsError = false
            this.saveStore()
          }

          if (this.isFunction(callback)) {
            callback(response.data[0])
            return
          }

        })
        .catch(e => {
          console.error('Unable to load stats:', e)
          this.getStore().stats = {}
          this.getStore().statsError = true
        })

      },



      // -- MetaData for tables and table strucutures  ----------------------

      getMeta (key) {
        let array = this.getConfig().meta

        for (var i = 0; i < array.length; i++) {
//          console.log(array[i].hasOwnProperty(key), array[i][key])
          if (array[i].hasOwnProperty(key)) {
            return this.fixFields(array[i][key])
          }
        }
        return null
      },



      // Needed for _id with default values, since they cause 422 errors on create.
      fixFields (array) {

        if (array.struct) {

          for (let type in array.struct) {
            if (type.endsWith('_id') && array.struct[type] === 0) {
              array.struct[type] = null
            } else {

              let t = array.meta[type].type.toLowerCase()

              switch (t) {
                case 'integer':
                  if (!type.endsWith('_id') && !array.struct[type]) {
                    array.struct[type] = 0
                  }
                  break

                case 'double':
                  if (!array.struct[type]) {
                    array.struct[type] = 0.0
                  } else {
                    array.struct[type] = Number(array.struct[type])
                  }
                  break

              }
//              console.log('meta', type, t, array.struct[type])
            }
          }
        }

        return array
      },



      getTableStruct (table) {
        let struct = this.getMeta(table).struct

        if (struct) {

          return this.clone(struct)

        } else {
          let msg = 'Fetching structure for \'' + table + '\' returned null.'

          this.$message({message: msg, type: 'error'})
          console.error(msg)
        }

      },



      // -- Helpers for JavaSrcipt stuff -----------------------------------

      isArray (value) {
        return Array.isArray(value)
      },
      /*
      // Apparently not. Yet MDN says Yes.
      isBigInt (value) {
        return (typeof value === 'bigint')
      },
      */

      isBoolean (value) {
        return (typeof value === 'boolean')
      },



      isDate (value) {
        return (value instanceof Date)
      },



      isFunction (value) {
        return (typeof value === 'function')
      },



      isString (value) {
        return (typeof value === 'string')
      },



      isNull (value) {
        return (value === null)
      },



      isNumber (value) {
        return Number.isInteger(value) || Number.parseFloat(value)
      },



      isJsObject (value) {
        return (typeof value === 'object')
      },



      isUndefined (value) {
        return (typeof value === 'undefined')
      },



      getType (prim) {

        if (prim) {
          switch (prim) {
            case prim === Array:
              return 'array'
            case prim === Boolean:
              return 'boolean'
            case prim === Date:
              return 'date'
            case prim === Function:
              return 'function'
            case prim === Number:
              return 'number'
            case prim === String:
              return 'string'
            case prim === Object:
              return 'object'
            default:
              return 'undefined'
          }
        }
        return null
      },



      getPrimType (text) {
        let tx = text.toLowerCase()

        if (tx) {
          switch (tx) {
            case tx === 'array' || tx === 'list':
              return Array
            case tx === 'boolean' || tx === 'checkbox':
              return Boolean
            case tx === 'date' || tx === 'datetime':
              return Date
            case tx === 'number' || tx === 'integer' || tx === 'float' || tx === 'decimal':
              return Number
            case tx === 'string' || tx === 'text' || tx === 'text editor' || tx === 'html':
              return String
            default:
              return 'undefined'
          }
        }
        return null
      },



      setProp (target, source) {
        if (source) {
          target = source
        } else {
          target = null
        }

        return target
      },



      removeNullArray (list) {
        if (!list) {
          return null
        }

        for (var i = 0; i < list.length; i++) {

          if (!list[i]) {
            list.splice(i, 1)
          }

        }  // for

        return list
      },


      arrayFindIndex (arr, value) {
        if (arr && this.isArray(arr) && value) {

          for (let i = 0; i <= arr.length; i++) {
            if (arr[i] === value) {
              return i
            }

          } // for
        }

        return null
      },



      arrayRemoveIndex (arr, index) {

        if (!arr && !this.isArray(arr) && !index) {
          return null
        }

        if (arr.length > index) {
          arr.splice(index, 1)
        }
        return arr
      },



      trim (str) {
        return str.replace(/^\s+|\s+$/gm, '')
      },



      strIf (str1, str2 = '', append = null, append2 = false) {
        str2 = (str2 ? str2 : '')  // To handle null variables
        return str1 ? str1 + (append ? append : '') : str2 + (append && append2 ? append : '')
      },



      sum (a, p, callback = null) {
        var r = 0

        if (a && p) {
          for (var i = 0; i < a.length; i++) {
            if (callback) {
              r += callback(a[i], p, r)
            } else {
              r += Number(a[i][p])
            }
          }
        }

        return r
      },



      isEmptyObject (obj) {
        for (let key in obj) {

          if (obj.hasOwnProperty(key)) {
            return false
          }

        } // for

        return true
      },



      bool (value) {
        if (value) {
          if (value === 1 || value === true || value.toUpperCase() === 'YES' || value.toUpperCase() === 'TRUE') {
            return true
          } else {
            return false
          }
        } else {
          return null
        }
      },



      clone (data) {
        return JSON.parse(JSON.stringify(data))
      },


      /**
       * Quick a dirty pluraliser- for a more exact one, use FormattingMixins: pluralise
       */
      plural (singular, num, addNumber = false, plural = null) {
        let message = (Number(num) === 1 ? singular : (plural || `${singular}s`))
        return addNumber === false ? message : `${num} ${message}`
      },


      equalJson (obj1, obj2) {

        if (!obj1 || !obj2) {
          console.log('equalJson: obj1 or obj2 null')
          return false
        }
        let ret = true

        for (var i in obj2) {
           if (!obj1.hasOwnProperty(i) || obj2[i] !== obj1[i]) {
              ret = false
           }
        }

      return ret
    },


      // -- Misc. stuff ------------------------------------------------

      hasLandowner (site) {
        return (site && site.tenancy && site.tenancy.owner)
      },



      hasTenancy (site) {
        return (site && site.tenancy)
      },


      hasSingleTenancy (site) {
        return (this.hasTenancy(site) && !this.isArray(site.tenancy))
      },



      hasTenancyRenewal (site) {
        return (this.hasSingleTenancy(site.tenancy) && site.tenancy.renewal)
      },



      getUtilLabel (data = null) {

        let str = null

        if (data) {

          if (data.tenancy && data.tenancy.util) {
            str = (data.tenancy.util.shortName ? data.tenancy.util.shortName : (data.tenancy.util.name ? data.tenancy.util.name : 'Util.'))
          }
        }

/*
        if (!str && cfg && cfg.orgUtilities && cfg.orgUtilities.length === 1) {
          return cfg.orgUtilities[0].shortName
        } else {
          str = 'Util.'
        }
*/
        if (!str && config && config.orgUtilities && config.orgUtilities.length === 1) {

          return config.orgUtilities[0].shortName

        } else {

          if (!str) {
            str = 'Util.'
          }

        }

        return str
      } // getUtilLabel

    }
  }
)

Vue.mixin(AccessMixins)

router.beforeEach((to, from, next) => {

  // KAN-39: allowlist auth-related routes; everything else needs a valid JWT.
  const path = to.path || ''
  if (path === '/login' || path === '/logout' || path.indexOf('/login') === 0 || path.indexOf('/logout') === 0) {
    next()
    return
  }

  if (authLib.isAuthenticated()) {
    if (!store.state.isLoggedIn) {
      store.state.isLoggedIn = true
    }
    next()
  } else {
    store.state.isLoggedIn = false
    next('/login')
  }

})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  //  mixins: [AccessMixins],
  template: '<App/>',
  components: { App },
  data: store
})
